/* eslint-disable no-unused-vars */

import axios from '../../axios'

export function summonsGetStatictics() {
  return async (dispatch) => {
    try {
      const response = await axios.get('Summons/statistics')
      dispatch({
        type: 'SUMMONS_STATISTICS_FULFILLED',
        payload: {
          data: response.data,
          error: null,
        },
      })
    } catch (e) {
      dispatch({
        type: 'SUMMONS_STATISTICS_REJECTED',
        payload: {
          data: null,
          error: {
            name: e.name,
            message: e.message,
          },
        },
      })
    }
  }
}
export function summonsGetById(summonId) {
  return async (dispatch) => {
    try {
      dispatch({ type: 'SUMMONS_GET_BYID_CLEAR' })

      const response = await axios.get(
        `Summons/${summonId}?filter=${encodeURIComponent(
          JSON.stringify({
            include: [
              {
                relation: 'issuer',
                scope: {
                  include: 'patrollers',
                },
              },
              {
                relation: 'summoner',
                scope: {
                  fields: ['staffId', 'name', 'phoneNumber', 'email', 'id'],
                },
              },
              {
                relation: 'offender',
              },
              {
                relation: 'vehicle',
              },
              {
                relation: 'infarctions',
              },
              {
                relation: 'pictures',
              },
              {
                relation: 'transactions',
                scope: {
                  include: {
                    relation: 'summoner',
                    scope: {
                      fields: ['staffId', 'name', 'phoneNumber', 'email', 'id'],
                    },
                  },
                  order: 'timestamp DESC',
                },
              },
            ],
          })
        )}`
      )

      if (!response.data) {
        dispatch({
          type: 'SUMMONS_GET_BYID_REJECTED',
          payload: { error: 'Removed', loaded: true, data: null },
        })
      } else {
        dispatch({
          type: 'SUMMONS_GET_BYID_FULFILLED',
          payload: {
            data: response.data,
            loaded: true,
            error: null,
          },
        })
      }
    } catch (e) {
      dispatch({
        type: 'SUMMONS_GET_BYID_REJECTED',
        payload: {
          loaded: true,
          data: null,
          error: {
            name: e.name,
            message: e.message,
          },
        },
      })
    }
  }
}
export function summonsDetailFineCommit(summonId, val) {
  return (dispatch) => {
    dispatch({
      type: 'SUMMONS_DETAIL_MODIFY_FINE',
      payload: { id: summonId, val: val },
    })
  }
}
export function summonsClrDetail() {
  return async (dispatch) => {
    dispatch({ type: 'SUMMONS_GET_BYID_CLEAR' })
  }
}
export function summonsApprove(summonId, fine, reason, onApproveErr) {
  const attr = {}
  attr.fine = fine
  if (reason !== null || reason !== '') {
    attr.remark = reason
  }

  return async (dispatch) => {
    try {
      const response = await axios.patch(`Summons/${summonId}/approve`, attr)
      dispatch({
        type: 'SUMMONS_CREATE_APPROVED_FULFILLED',
        payload: {
          data: response.data,
          error: null,
        },
      })
      onApproveErr(null)
    } catch (e) {
      if (e.response) {
        onApproveErr(e.response.data.error)
        dispatch({
          type: 'SUMMONS_CREATE_APPROVED_REJECTED',
          payload: {
            data: null,
            error: {
              name: e.response.data.error.name,
              message: e.response.data.error.message,
            },
          },
        })
      }
    }
  }
}
export function summonApproveSuccessful(summon) {
  return (dispatch) => {
    dispatch({
      type: 'SUMMONS_ISSUED_REMOVE_BYID',
      payload: summon.ref,
    })
    dispatch(summonsGetStatictics())
    // dispatch(summons__get_issued(0, 10))
    dispatch(summonsGetApproved(0, 10))
  }
}
export function summonArchive(summonId, reason, onArchiveErr) {
  return async (dispatch) => {
    try {
      const response = await axios.patch(`Summons/${summonId}/reject`, {
        remark: reason,
      })
      dispatch({
        type: 'SUMMONS_CREATE_ARCHIVED_FULFILLED',
        payload: {
          data: response.data,
          error: null,
        },
      })
      onArchiveErr(null)
    } catch (e) {
      onArchiveErr(e.response.data.error)
      dispatch({
        type: 'SUMMONS_CREATE_ARCHIVED_REJECTED',
        payload: {
          data: null,
          error: {
            name: e.response.data.error.name,
            message: e.response.data.error.message,
          },
        },
      })
    }
  }
}
export function summonArchiveSuccessful(summon) {
  return (dispatch) => {
    dispatch({
      type: 'SUMMONS_ISSUED_REMOVE_BYID',
      payload: summon.ref,
    })
    dispatch(summonsGetStatictics())
    // dispatch(summons__get_issued(0, 10))
    dispatch(summonsGetApproved(0, 10))
    dispatch(summonsGetArchived(0, 10))
  }
}

export function summonsIssuedTypeahead(cb) {
  return async (dispatch) => {
    try {
      const response = await axios.get('Summons/pending/typeahead')
      // console.log("summons__get_issued > response : \n", response);
      dispatch({
        type: 'SUMMONS_ISSSUED_TYPEAHEAD_FULFILLED',
        payload: {
          data: response.data,
          error: null,
        },
      })
    } catch (e) {
      dispatch({
        type: 'SUMMONS_ISSSUED_TYPEAHEAD_REJECTED',
        payload: {
          data: null,
          error: {
            name: e.name,
            message: e.message,
          },
        },
      })
    }
  }
}
export function summonGetTypeaheadSummon() {
  return async (dispatch) => {
    try {
      const response = await axios.get('Summons/approved/typeahead')
      // console.log("summons__get_issued > response : \n", response);
      dispatch({
        type: 'SUMMONS_APPROVED_TYPEAHEAD_FULFILLED',
        payload: {
          data: response.data,
          error: null,
        },
      })
    } catch (e) {
      dispatch({
        type: 'SUMMONS_APPROVED_TYPEAHEAD_REJECTED',
        payload: {
          data: null,
          error: {
            name: e.name,
            message: e.message,
          },
        },
      })
    }
  }
}

export function summonsGetIssued(skip, limit) {
  // console.log("debug: dispatching summons__get_issued....");
  return async (dispatch) => {
    try {
      const response = await axios.get(
        `Summons/pending?offset=${skip}&limit=${limit}`
      )
      dispatch({
        type: 'SUMMONS_ISSUED_GET_FULFILLED',
        payload: {
          data: response.data,
          error: null,
        },
      })
    } catch (e) {
      dispatch({
        type: 'SUMMONS_ISSUED_GET_REJECTED',
        payload: {
          data: null,
          error: {
            name: e.name,
            message: e.message,
          },
        },
      })
    }
  }
}
export function summonsGetIssuedFiltered(skip, limit, filter) {
  return async (dispatch) => {
    try {
      dispatch({
        type: 'SUMMONS_ISSUED_GET_PENDING',
        payload: {
          data: filter,
          error: null,
        },
      })
      const response = await axios.get(
        `Summons/pending/filtered?skip=${skip}&limit=${limit}&filter=${encodeURIComponent(
          JSON.stringify(filter)
        )}`
      )
      dispatch({
        type: 'SUMMONS_ISSUED_GET_FULFILLED',
        payload: {
          data: response.data,
          error: null,
        },
      })
    } catch (e) {
      dispatch({
        type: 'SUMMONS_ISSUED_GET_REJECTED',
        payload: {
          response: null,
          error: {
            name: e.name,
            message: e.message,
          },
        },
      })
    }
  }
}
export function summonsIssuedOnItemsPerPage(count) {
  return (dispatch) => {
    dispatch({
      type: 'SUMMONS_ISSUED_ITEMPERPAGE',
      payload: {
        count,
      },
    })
  }
}
export function summonsIssuedOnCurrentPageChanged(page) {
  return (dispatch) => {
    dispatch({
      type: 'SUMMONS_ISSUED_CURRENTPAGE',
      payload: {
        page,
      },
    })
  }
}
export function summonsIssuedOnClear() {
  return (dispatch) => {
    dispatch({
      type: 'SUMMONS_ISSUED_CLEAR',
      payload: null,
    })
  }
}

export function summonsApprovedOnItemsPerPage(count) {
  return (dispatch) => {
    dispatch({ type: 'SUMMONS_APPROVED_ITEMPERPAGE', payload: count })
  }
}
export function summonsApprovedOnCurrentPageChanged(page) {
  return (dispatch) => {
    dispatch({ type: 'SUMMONS_APPROVED_CURRPAGE', payload: page })
  }
}
export function summonsGetApproved(skip, limit) {
  return async (dispatch) => {
    try {
      const response = await axios.get(
        `Summons/approved?offset=${skip}&limit=${limit}`
      )
      dispatch({
        type: 'SUMMONS_APPROVED_GET_FULFILLED',
        payload: {
          data: response.data,
          error: null,
        },
      })
    } catch (e) {
      dispatch({
        type: 'SUMMONS_APPROVED_GET_REJECTED',
        payload: {
          data: null,
          error: {
            name: e.name,
            message: e.message,
          },
        },
      })
    }
  }
}
export function summonsGetApprovedFiltered(skip, limit, filter) {
  return async (dispatch) => {
    try {
      dispatch({
        type: 'SUMMONS_APPROVED_GET_PENDING',
        payload: {
          data: filter,
          error: null,
        },
      })
      const response = await axios.get(
        `Summons/approved/filtered?skip=${skip}&limit=${limit}&filter=${encodeURIComponent(
          JSON.stringify(filter)
        )}`
      )
      dispatch({
        type: 'SUMMONS_APPROVED_GET_FULFILLED',
        payload: {
          data: response.data,
          error: null,
        },
      })
    } catch (e) {
      dispatch({
        type: 'SUMMONS_APPROVED_GET_REJECTED',
        payload: {
          response: null,
          error: {
            name: e.name,
            message: e.message,
          },
        },
      })
    }
  }
}
export function summonsClrApproved() {
  return (dispatch) => {
    dispatch({
      type: 'SUMMONS_APPROVED_CLEAR',
      payload: null,
    })
  }
}

export function summonsArchivedOnItemsPerPage(count) {
  return (dispatch) => {
    dispatch({ type: 'SUMMONS_ARCHIVED_ITEMPERPAGE', payload: count })
  }
}
export function summonsArchivedOnCurrentPageChanged(page) {
  return (dispatch) => {
    dispatch({ type: 'SUMMONS_ARCHIVED_CURRPAGE', payload: page })
  }
}
export function summonsGetArchived(skip, limit) {
  return async (dispatch) => {
    try {
      const response = await axios.get(
        `Summons/archived?offset=${skip}&limit=${limit}`
      )
      dispatch({
        type: 'SUMMONS_ARCHIVED_GET_FULFILLED',
        payload: {
          data: response.data,
          error: null,
        },
      })
    } catch (e) {
      dispatch({
        type: 'SUMMONS_ARCHIVED_GET_REJECTED',
        payload: {
          data: null,
          error: {
            name: e.name,
            message: e.message,
          },
        },
      })
    }
  }
}
export function summonsClrArchived() {
  return (dispatch) => {
    dispatch({
      type: 'SUMMONS_ARCHIVED_CLEAR',
      payload: null,
    })
  }
}
export function summonsGetArchivedFiltered(skip, limit, filter) {
  return async (dispatch) => {
    try {
      dispatch({
        type: 'SUMMONS_ARCHIVED_GET_PENDING',
        payload: {
          data: filter,
          error: null,
        },
      })
      const response = await axios.get(
        `Summons/archived/filtered?skip=${skip}&limit=${limit}&filter=${encodeURIComponent(
          JSON.stringify(filter)
        )}`
      )
      dispatch({
        type: 'SUMMONS_ARCHIVED_GET_FULFILLED',
        payload: {
          data: response.data,
          error: null,
        },
      })
    } catch (e) {
      dispatch({
        type: 'SUMMONS_ARCHIVED_GET_REJECTED',
        payload: {
          response: null,
          error: {
            name: e.name,
            message: e.message,
          },
        },
      })
    }
  }
}
